<template>
    <v-card>
        <v-form
                ref="entry-form"
        >
            <v-card-title>

            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="editableEntry.text"
                            :label="$t('form.entry.text.label')"
                            :placeholder="$t('form.entry.text.placeholder')"
                            :error-messages="textErrors"
                            required
                            @blur="$v.editableEntry.text.$touch()"
                        ></v-textarea>
                    </v-col>

                    <v-col cols="12">
                        <v-select
                                v-model="editableEntry.sector"
                                :items="sectors"
                                :label="$t('form.blob.sectors.label')"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-slider
                                v-model="editableEntry.sector_progress"
                                :label="$t('form.blob.sector_progress.label')"
                                step="1"
                                max="10"
                                thumb-label="always"
                                ticks
                        ></v-slider>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn
                        text
                        @click="close"
                >
                    {{ $t('controls.cancel') }}
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn icon right color="error" v-if="!isNew" @click="openDeleteDialog">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>

                <v-btn
                        dark
                        @click="save"
                >
                   <span v-if="isNew">
                        {{ $t('controls.create') }}
                    </span>
                        <span v-else>
                        {{ $t('controls.save') }}
                    </span>
                </v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
  import { minLength, required } from 'vuelidate/lib/validators'
  import { validationMixin } from 'vuelidate'
  import { mapGetters } from 'vuex'

  export default {
    name: 'EntryForm',
    mixins: [validationMixin],
    validations: {
      editableEntry: {
        text: {
          required,
          minLength: minLength(10),
        }
      }
    },
    props: {
      blobEntry: {
        type: Object,
        required: true
      },
      cancel: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        editableEntry: Object.assign({
          text: '',
          blob_id: 0
        }, this.blobEntry)
      }
    },

    computed: {
      ...mapGetters({
        radar: 'radars/getCurrentRadar',
        blobId: 'blobs/getCurrentBlobId'
      }),

      isNew: function () {
        return this.editableEntry.id === undefined
      },

      textErrors () {
        const errors = []
        if (!this.$v.editableEntry.text.$dirty) return errors
        !this.$v.editableEntry.text.required && errors.push(this.$t('form.entry.text.required'))
        !this.$v.editableEntry.text.minLength && errors.push(this.$t('form.entry.text.min-length'))
        return errors
      },

      sectors () {
        return [
          { text: this.radar.sector_3, value: 3 },
          { text: this.radar.sector_2, value: 2 },
          { text: this.radar.sector_1, value: 1 },
          { text: this.radar.sector_0, value: 0 },
        ]
      }
    },
    methods: {
      save () {
        this.$v.$touch()

        if (!this.$v.$invalid) {
          let dispatchMethod = this.isNew ? 'blobs/createBlobEntry' : 'blobs/updateBlobEntry'

          if (this.editableEntry.blob_id === 0)
            this.editableEntry.blob_id = this.blobId

          this.$store.dispatch(dispatchMethod, this.editableEntry)
            .then(() => {
              if (this.isNew) {
                // reset form
                this.editableEntry = {}
                this.$refs['entry-form'].reset()

                this.$store.commit('notification/newNotification', {
                  text: this.$t('form.entry.created')
                })
              } else {
                this.$store.commit('notification/newNotification', {
                  text: this.$t('form.entry.updated')
                })
              }

              this.$emit('entryIsProcessed')
            })
        }
      },
      close () {
        this.$emit('entryIsCanceled')
      },
      openDeleteDialog () {
        const deletedText = this.$t('form.entry.removed')

        this.$store.commit('prompt/newPrompt', {
          title: this.$t('dialog.delete.title') + ' ' + this.$t('dialog.delete.entry.title'),
          text: this.$t('dialog.delete.entry.text'),

          execCallback: function () {
            this.$store.dispatch('blobs/removeBlobEntry', this.editableEntry)
              .then(() => {
                this.$emit('entryIsProcessed')

                this.$store.commit('notification/newNotification', {
                  text: deletedText
                })
              })
          }.bind(this)
        })
      },
    },
    watch: {
      entry: function (value) {
        this.editableEntry = Object.assign({}, value)
      }
    }
  }
</script>
